import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { DealerFeature, ModelsFeature, type ApiTypes } from '@hyundai/ng-common-lib';
import { M030C110ModelHeroComponent, M040C110ModelSelectComponent } from '@hyundai/ui';
import { getRouterSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-model-list-page',
    standalone: true,
    imports: [M040C110ModelSelectComponent, M030C110ModelHeroComponent],
    templateUrl: './model-list-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class ModelListPageComponent {
    readonly ALL_LABEL = 'Alle';

    store = inject(Store);
    router = inject(Router);
    activatedRoute = inject(ActivatedRoute);

    queryParams = toSignal(this.activatedRoute.queryParamMap);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    locationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    modelList = this.store.selectSignal(ModelsFeature.state.selectLoadedModelList);

    currentRoute = this.store.selectSignal(getRouterSelectors().selectUrl);

    activeCategory = computed(() => {
        const filterQueryParam = this.queryParams()?.get('filter');

        return filterQueryParam ?? this.ALL_LABEL;
    });
    categories = computed(() => {
        const modelList = this.modelList();
        if (modelList && modelList.categories) {
            return [this.ALL_LABEL, ...modelList.categories];
        }
        return [this.ALL_LABEL];
    });

    filteredModels = computed(() => {
        const modelList = this.modelList();
        if (!modelList) return [];

        const filterQueryParam = this.queryParams()?.get('filter');

        if (!filterQueryParam) return modelList.models;

        return modelList.models.filter((model) =>
            model.categories.includes(filterQueryParam as ApiTypes.ModelCategory),
        );
    });

    categorySelected(category: string) {
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { filter: category === this.ALL_LABEL ? undefined : category },
        });
    }
}
